module.exports = __webpack_public_path__ + "static/media/starred.a9af33ee.svg";